import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import { InputField } from '../../../ui/components/index.js'
import * as publicacionesService from '../../servicios/publicacionesService'
import styles from './AdministrarPublicacion.module.css'

const Exposicion = ({ idExposicionNueva, onChangeState }) => {
  const [exposiciones, setExposiciones] = useState([])

  const obtenerExposiciones = async () => {
    const exposicionRtn = await publicacionesService.buscarExposicion('')
    setExposiciones(exposicionRtn.data)
  }

  const handleChange = ({ name, value }) => {
    onChangeState(name, parseInt(value))
  }

  useEffect(() => {
    obtenerExposiciones()
  }, [])

  return (
    <div className={styles.columnaLeft}>
      {exposiciones.map((exposicion) => (
        <InputField
          key={exposicion.idPublicacionExposicion}
          className={styles.input}
          type="radio"
          name="idPublicacionExposicion"
          label={`Exposición ${exposicion.nombre}`}
          checked={idExposicionNueva === exposicion.idPublicacionExposicion}
          value={exposicion.idPublicacionExposicion}
          onChange={(e) => handleChange(e.target)}
        />
      ))}
    </div>
  )
}

Exposicion.propTypes = {
  idExposicionNueva: PropTypes.number.isRequired,
  idExposicionAnterior: PropTypes.number.isRequired,
  onChangeState: PropTypes.func.isRequired
}

export default Exposicion
